// Google profile share URL for AB Car details
export const GOOGLE_PROFILE_URL = "https://share.google/jhIkORF9b9b33W8B3";

// Force-open helper that bypasses any preview iframe / visual-edit click interception.
export function openGoogleProfile(e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  window.open(GOOGLE_PROFILE_URL, "_blank", "noopener,noreferrer");
}
